import { usingGet } from '@ocean/api'

export const getListSimulatorTrainings = () => usingGet('SimulatorTrainings/ListSimulatorTrainings')
